
export interface IpInfo {
    city: string;
    country: string;
    hostname: string;
    ip: string;
    loc: string;
    org: string;
    postal: string;
    position: { lat: string, long: string };
    region: string;
}
